<template>
  <div :class="b()">
    <transition name="opacity">
      <SharedNotification
        v-if="isNotificationShow"
        :class="b('notification')"
      />
    </transition>

    <transition name="opacity">
      <SharedModal v-if="isModalShow" :class="b('modal')" />
    </transition>

    <transition name="opacity">
      <SharedDeposit v-if="isDepositShow" :class="b('modal')" />
    </transition>

    <DefaultLayout
      v-if="!!userRepo.userInfo.id && displayedLayout === 'default'"
    />

    <AuthLayout v-if="displayedLayout === 'auth'" />

    <AdminLayout v-if="displayedLayout === 'admin'" />

    <LandingLayout v-if="displayedLayout === 'landing'" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

import {
  AdminLayout,
  AuthLayout,
  DefaultLayout,
  LandingLayout,
} from "@/layouts";
import {
  SharedNotification,
  SharedModal,
  SharedDeposit,
} from "@/components/shared";

import { Layout } from "@/shared/constants/enums";
import { initTawkWithUser } from "@/utils/tawk";

export default defineComponent({
  name: "app",
  components: {
    AuthLayout,
    DefaultLayout,
    AdminLayout,
    LandingLayout,
    SharedNotification,
    SharedModal,
    SharedDeposit,
  },
  data() {
    return {
      isLoading: false,
      userRepo: this.$projectServices.userRepo,
      modalRepo: this.$projectServices.modalRepo,
      notificationRepo: this.$projectServices.notificationRepo,
      depositWithdrawalRepo: this.$projectServices.depositWithdrawalRepo,
      authRepository: this.$projectServices.authRepository,
      parserRepository: this.$projectServices.parserRepository,
      currentVersion: "",
    };
  },
  async created() {
    try {
      await this.authRepository.csfr();

      this.isLoading = true;
    } catch (e) {
      this.isLoading = true;
      console.log(e);
    }
  },
  mounted() {
    this.checkVersion();
    setInterval(this.checkVersion, 100000);
  },
  watch: {
    "userRepo.userInfo": {
      handler(newUserInfo) {
        if (newUserInfo && newUserInfo.id && newUserInfo.email) {
          initTawkWithUser(
            newUserInfo.id,
            newUserInfo.email,
            newUserInfo.name || undefined
          );
        }
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {
    displayedLayout(): Layout {
      const { layout } = this.$route.meta;

      return layout as Layout;
    },

    isNotificationShow(): boolean {
      return !!this.notificationRepo.notification;
    },

    isModalShow(): boolean {
      return !!this.modalRepo.modal;
    },

    isDepositShow(): boolean {
      const { id, currency_id } = this.depositWithdrawalRepo.deposit;
      return !!id && !!currency_id;
    },
  },
  methods: {
    async checkVersion() {
      try {
        const res = await fetch("/version.json", { cache: "no-cache" });
        const { version } = await res.json();

        if (this.currentVersion && version !== this.currentVersion) {
          console.log("Новая версия фронта. Обновляем...");
          window.location.reload();
        }

        this.currentVersion = version;
      } catch (e) {
        console.error("Ошибка при проверке версии:", e);
      }
    },
  },
});
</script>

<style lang="scss">
.app {
  @include full-screen;

  position: relative;

  &__notification {
    position: fixed;
    top: 30px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 200;
  }

  &__modal {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 999999;
  }

  .opacity-enter-active {
    transition: $transition;
  }

  .opacity-leave-active {
    transition: $transition;
  }

  .opacity-enter-from,
  .opacity-leave-to {
    opacity: 0;
  }
}
</style>
